import React from 'react';
import Slider from 'react-slick';
import Img from 'react-image';
import Menu from './Menu';
import pcHero1 from '../static/images/pc/hero1.jpg';
import pcHero2 from '../static/images/pc/hero2.jpg';
import pcHero3 from '../static/images/pc/hero3.jpg';
import pcHero4 from '../static/images/pc/hero4.jpg';
import spHero1 from '../static/images/sp/hero1.jpg';
import spHero2 from '../static/images/sp/hero2.jpg';
import spHero3 from '../static/images/sp/hero3.jpg';
import spHero4 from '../static/images/sp/hero4.jpg';
import cotoiroLogo from '../static/images/cotoiro.png';


export default class Sliderer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nav1: null,
      nav2: null,
      mq: null,
    };

    this.settings = {
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    this.infoList = [
      {
        date: '2020.03.30',
        content: '<a href="https://www.facebook.com/cotoiro.iwabuchi" target="_black" rel="noopener noreferrer">新型コロナウイルス感染拡大に伴うコトイロ休業のお知らせ ※随時Facebook上で状況を更新してまいります。</a>',
      },
      {
        date: '2019.09.20',
        content: '<a href="https://shukubamachi-marche.localinfo.jp/" target="_black" rel="noopener noreferrer">9月28日（土）に宿場町まるしぇを北区花火会と同時開催します！</a>',
      },
      {
        date: '2019.09.05',
        content: '<a href="https://juas.or.jp/seminar_event/event/2454/" target="_black" rel="noopener noreferrer">co-toiro iwabuchi を運営する㈱岩淵家守舎が「JUAS TECH PITCH2019」でベストアワードを受賞いたしました。</a>',
      },
      {
        date: '2019.04.27',
        content: '<a href="https://shukubamachi-marche.localinfo.jp/" target="_black" rel="noopener noreferrer">6月22日（土）に宿場町まるしぇを開催します！</a>',
      },
      {
        date: '2019.04.27',
        content: '<a href="https://shukubamachi-marche.localinfo.jp/" target="_black" rel="noopener noreferrer">5月25日（土）に宿場町まるしぇを開催します！</a>',
      },
      {
        date: '2019.03.30',
        content: '<a href="https://shukubamachi-marche.localinfo.jp/" target="_black" rel="noopener noreferrer">1周年を迎える宿場町まるしぇを開催します。</a>',
      },
      {
        date: '2019.02.02',
        content: 'co-toiro iwabuchi を運営する㈱岩淵家守舎が北区ビジネスプランコンテストで最優秀賞を受賞いたしました。',
      },
      {
        date: '2018.12.18',
        content: 'co-toiro iwabuchi を運営する㈱岩淵家守舎の活動が読売新聞に掲載されました。',
      },
      {
        date: '2018.10.04',
        content: 'サイトをリニューアルしました。',
      },
    ];
  }

  componentDidMount() {
    const mediaQueryOverPhoneSize = 767;
    this.mq = window.matchMedia(`(min-width: ${mediaQueryOverPhoneSize}px)`);

    this.setState({
      nav1: this.slider1,
      nav2: this.slider2,
      mq: this.mq,
    });

    this.mq.addListener(() => {
      this.setState({
        mq: this.mq,
      });
    });
  }

  render() {
    return (this.state.mq ? this.state.mq.matches : null)
      ? (
          <div className="p-slick-container">
            <Slider
              asNavFor={this.state.nav2}
              dots={false}
              autoplay={true}
              ref={slider => (this.slider1 = slider)}
              {...this.props}
              {...this.settings}
            >
              <Img src={pcHero1} alt="" />
              <Img src={pcHero2} alt="" />
              <Img src={pcHero3} alt="" />
              <Img src={pcHero4} alt="" />
            </Slider>
            <div className="p-slick-overlay" />
            <div className="p-hero__body">
              <Slider
                className="p-slick-slider"
                dotsClass="slick-dots p-slick-dots"
                asNavFor={this.state.nav1}
                dots={true}
                ref={slider => (this.slider2 = slider)}
                {...this.settings}
              >
                <div>■</div>
                <div>■</div>
                <div>■</div>
                <div>■</div>
              </Slider>
              <Img src={cotoiroLogo} alt="コトイロ ロゴ" className="p-hero__logo" />
              <Menu color="-white" />
              <div className="p-hero__menu">
                <div className="p-hero__menu--title">
                  NEWS
                </div>
                <ul className="p-hero__menu--list">
                  {this.infoList.map(({ date, content }) => (
                    <li><span>{date}</span><span dangerouslySetInnerHTML={{ __html: content}} /></li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )
      : (
          <div className="p-slick-container">
            <Slider
              asNavFor={this.state.nav2}
              dots={false}
              autoplay={true}
              ref={slider => (this.slider1 = slider)}
              {...this.props}
              {...this.settings}
            >
              <Img src={spHero1} alt="" />
              <Img src={spHero2} alt="" />
              <Img src={spHero3} alt="" />
              <Img src={spHero4} alt="" />
            </Slider>
            <div className="p-slick-overlay" />
            <div className="p-hero__body">
              <Slider
                className="p-slick-slider"
                dotsClass="slick-dots p-slick-dots"
                asNavFor={this.state.nav1}
                dots={true}
                ref={slider => (this.slider2 = slider)}
                {...this.settings}
              >
                <div>■</div>
                <div>■</div>
                <div>■</div>
                <div>■</div>
              </Slider>
              <Img src={cotoiroLogo} alt="コトイロ ロゴ" className="p-hero__logo" />
              <Menu color="-white" />
              <div className="p-hero__menu">
                <div className="p-hero__menu--title">
                  NEWS
                </div>
                <ul className="p-hero__menu--list -sp">
                  {this.infoList.map(({ date, content }) => (
                    <li><span>{date}</span><span dangerouslySetInnerHTML={{ __html: content}} /></li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/components/Slider.js